export default "__VITE_ASSET__BRBBS56D__"